/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Feature_Resume_DescInputs */

const en_landing_feature_resume_desc = /** @type {(inputs: Landing_Feature_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically adapt your resume to match any job description with ATS-optimized formatting. Our AI detects missing keywords and adds them strategically so your CV passes automated screening filters.`)
};

const de_landing_feature_resume_desc = /** @type {(inputs: Landing_Feature_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passe deinen Lebenslauf automatisch an jede Stellenbeschreibung an, mit ATS-optimierter Formatierung. Unsere KI erkennt fehlende Schluesselwoerter und ergaenzt sie gezielt, damit dein CV die automatischen Filter passiert.`)
};

const fr_landing_feature_resume_desc = /** @type {(inputs: Landing_Feature_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adapte automatiquement ton CV a chaque description de poste avec une mise en forme optimisee pour les ATS. Notre IA detecte les mots-cles manquants et les ajoute strategiquement pour passer les filtres automatiques.`)
};

const es_landing_feature_resume_desc = /** @type {(inputs: Landing_Feature_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adapte automaticamente su curriculum a cada descripcion de puesto con formato optimizado para ATS. Nuestra IA detecta palabras clave faltantes y las agrega estrategicamente para superar los filtros automaticos.`)
};

const it_landing_feature_resume_desc = /** @type {(inputs: Landing_Feature_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adatta automaticamente il tuo curriculum a qualsiasi descrizione di lavoro con formattazione ottimizzata per ATS. La nostra IA rileva le parole chiave mancanti e le aggiunge strategicamente per superare i filtri automatici.`)
};

const nl_landing_feature_resume_desc = /** @type {(inputs: Landing_Feature_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas je CV automatisch aan op elke vacaturetekst met ATS-geoptimaliseerde opmaak. Onze AI detecteert ontbrekende trefwoorden en voegt ze strategisch toe zodat je CV de automatische filters doorkomt.`)
};

const pl_landing_feature_resume_desc = /** @type {(inputs: Landing_Feature_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatycznie dostosuj CV do kazdego opisu stanowiska z formatowaniem zoptymalizowanym pod ATS. Nasza AI wykrywa brakujace slowa kluczowe i dodaje je strategicznie, aby Twoje CV przeszlo automatyczne filtry.`)
};

const fi_landing_feature_resume_desc = /** @type {(inputs: Landing_Feature_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mukauta ansioluettelosi automaattisesti vastaamaan mitae tahansa tyoepaikkakuvausta ATS-optimoidulla muotoilulla. Tekoaelymme tunnistaa puuttuvat avainsanat ja lisaeae ne strategisesti, jotta CV:si laepaesee automaattiset suodattimet.`)
};

const da_landing_feature_resume_desc = /** @type {(inputs: Landing_Feature_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilpas automatisk dit CV til enhver jobbeskrivelse med ATS-optimeret formatering. Vores AI opdager manglende noegleord og tilfoejer dem strategisk, saa dit CV passerer de automatiske filtre.`)
};

const sv_landing_feature_resume_desc = /** @type {(inputs: Landing_Feature_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anpassa automatiskt ditt CV till valfri jobbbeskrivning med ATS-optimerad formatering. Vaar AI identifierar saknade nyckelord och laegger till dem strategiskt saa att ditt CV passerar de automatiska filtren.`)
};

/**
* | output |
* | --- |
* | "Automatically adapt your resume to match any job description with ATS-optimized formatting. Our AI detects missing keywords and adds them strategically so yo..." |
*
* @param {Landing_Feature_Resume_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_feature_resume_desc = /** @type {((inputs?: Landing_Feature_Resume_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Feature_Resume_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_feature_resume_desc(inputs)
	if (locale === "fr") return fr_landing_feature_resume_desc(inputs)
	if (locale === "es") return es_landing_feature_resume_desc(inputs)
	if (locale === "it") return it_landing_feature_resume_desc(inputs)
	if (locale === "nl") return nl_landing_feature_resume_desc(inputs)
	if (locale === "pl") return pl_landing_feature_resume_desc(inputs)
	if (locale === "fi") return fi_landing_feature_resume_desc(inputs)
	if (locale === "da") return da_landing_feature_resume_desc(inputs)
	if (locale === "sv") return sv_landing_feature_resume_desc(inputs)
	return en_landing_feature_resume_desc(inputs)
});